export default function useErrors () {
    return (errors) => {
        for (let e in errors) {
            const firstError = errors[e][0];
            return handleError(firstError);
        }
    };
};

export const useError = () => {
    return (error) => handleError(error);
};

const handleError = (error) => {
    alert(error);
};